import CartWrapper from "pages/CartWrapper.tsx";
import MainCheckout from "pages/main-checkout.tsx";
import React, { lazy } from "react";
import WindowActionsProvider from "lib/contexts/WindowActionsProvider";
import { Routes, Route, useSearchParams } from "react-router-dom";

const PaymentStatus = lazy(() => import("../../pages/payment-status.tsx"));
const LoginCheck = lazy(() => import("../../pages/login-check.tsx"));
const GhostModal = lazy(() => import("../../pages/ghost.tsx"));
const MarketingPopup = lazy(() => import("../../pages/marketing-popup.tsx"));
const ExperimentWidget = lazy(() => import("../../pages/experiment-widget.tsx"));
const MockCheckout = lazy(() => import("../../pages/mock-checkout.tsx"));
const Wishlist = lazy(() => import("../../pages/wishlist.tsx"));
const ShopifyLogin = lazy(() => import("../../pages/shopify-login.tsx"));
const ProfilePage = lazy(() => import("../../pages/profile.tsx"));
const Accounts = lazy(() => import("../../pages/accounts.tsx"));

interface AppRouterProps {}

const AppRouter: React.FC<AppRouterProps> = ({}) => {
  return (
    <>
      <Routes>
        {/* Multiple route paths are not supported on Cloudflare. Hence avoid it. */}
        <Route path={`/payment-status`} element={<PaymentStatus />} />
        <Route path={`/`} element={<Routing />} />
      </Routes>
    </>
  );
};

const Routing: React.FC<AppRouterProps> = ({}) => {
  const [searchParams] = useSearchParams();
  const page = searchParams.get("page");
  switch (page) {
    case "payment-status":
      return <PaymentStatus />;
    case "cart":
    case "CART":
      return <WindowActionsProvider><CartWrapper /></WindowActionsProvider>;
    case "login-status-check":
      return <LoginCheck />;
    case "ghost-modal":
      return <GhostModal />;
    case "marketing-popup":
      return <WindowActionsProvider><MarketingPopup /></WindowActionsProvider>;
    case "wishlist":
      return <Wishlist />;
    case "account":
      return <WindowActionsProvider><Accounts /></WindowActionsProvider>;
    case "mock-checkout":
      return <MockCheckout />;
    case "experiments-widget":
      return <ExperimentWidget />;
    case "shopify-login":
      return <ShopifyLogin />;
    case "profile":
      return <ProfilePage/>
    default:
      return <WindowActionsProvider><MainCheckout /></WindowActionsProvider>;
  }
};

export default AppRouter;
